import {makeKey,update} from '../../../../utils/reducerOperations';
export function getUserProfileStarted(state, payload) {
    return makeKey(
        'getUserProfileApi',
        update(state.getUserProfileApi, {isProcessing: true})
    );
}